import { Route } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";

import AdminLayout from "../layouts/AdminLayout";

import Dashboard from "../pages/admin/AdminDashboard";
import Organizations from "../pages/admin/organizations/OrganizationsPage";
import Plans from "../pages/admin/plans/PlansPage";
import Subscriptions from "../pages/admin/subscriptions/SubscriptionsPage";
import Templates from "../pages/admin/templates/TemplatesPage";
import Creatives from "../pages/admin/creatives/CreativesPage";
import Campaigns from "../pages/admin/campaigns/CampaignsPage";
import Users from "../pages/admin/users/OrganizationUsersPage";

export default function AdminRoutes() {
  return (
    <Route
      path="/admin"
      element={
        <ProtectedRoute roles={["admin"]}>
          <AdminLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<Dashboard />} />

      <Route path="organizations" element={<Organizations />} />

      <Route path="plans" element={<Plans />} />

      <Route path="subscriptions" element={<Subscriptions />} />

      <Route path="templates" element={<Templates />} />

      <Route path="creatives" element={<Creatives />} />

      <Route path="campaigns" element={<Campaigns />} />

      <Route path="users" element={<Users />} />
    </Route>
  );
}